import { lowerFirst } from "lodash";

import { ILoginPinFrequencyModel } from "@/Common/Api/Employee/ILoginFrequencyModel";
import { PinFrequency } from "../UI/Enums";

class LoginPinFrequencyModel {
    public consultationRequestToken: string;
    public documentToken: string;
    public examRequestToken: string;
    public formToken: string;
    public prescriptionToken: string;
    public obstetricalFileToken: string;
    public consultationRequestFrequency: PinFrequency;
    public documentFrequency: PinFrequency;
    public examRequestFrequency: PinFrequency;
    public formFrequency: PinFrequency;
    public prescriptionFrequency: PinFrequency;
    public obstetricalFileFrequency: PinFrequency;

    public constructor(init?: Partial<LoginPinFrequencyModel>) {
        Object.assign(this, init);
    }

    public static fromResponseModel(response: ILoginPinFrequencyModel): LoginPinFrequencyModel {
        if (!response) {
            return new LoginPinFrequencyModel();
        }

        const model: Partial<LoginPinFrequencyModel> = {};
        for (const key of Object.keys(response))
            model[lowerFirst(key)] = response[key];

        return new LoginPinFrequencyModel(model);
    }

    public static toResponseModel(model: LoginPinFrequencyModel): ILoginPinFrequencyModel {
        const loginPinFrequencyModel = model ?? new LoginPinFrequencyModel();
        return {
            ConsultationRequestToken: loginPinFrequencyModel.consultationRequestToken,
            DocumentToken: loginPinFrequencyModel.documentToken,
            ExamRequestToken: loginPinFrequencyModel.examRequestToken,
            FormToken: loginPinFrequencyModel.formToken,
            PrescriptionToken: loginPinFrequencyModel.prescriptionToken,
            ObstetricalFileToken: loginPinFrequencyModel.obstetricalFileToken,
            ConsultationRequestFrequency: loginPinFrequencyModel.consultationRequestFrequency,
            DocumentFrequency: loginPinFrequencyModel.documentFrequency,
            ExamRequestFrequency: loginPinFrequencyModel.examRequestFrequency,
            FormFrequency: loginPinFrequencyModel.formFrequency,
            PrescriptionFrequency: loginPinFrequencyModel.prescriptionFrequency,
            ObstetricalFileFrequency: loginPinFrequencyModel.obstetricalFileFrequency
        };
    }
}

export { LoginPinFrequencyModel };
